import React, { Component } from "react";
import TreeAndTableLayout from "../../../components/TreeAndTableLayout/TreeAndTableLayout";
import "./ParamConfiguration.css";
import ToolBar from "./ToolBar/ToolBar";
import TableOperation from "./TableOperation/TableOperation";
import CmSwitch from "../../../components/CmSwitch/CmSwitch";
import { findCONFIGURATIONTYPEByValue } from "./config/paramConfiguration";
import BaseComponent from "../../../base/BaseComponent";
import { filterForEach, treeForEach, generateTreeData } from "../../../utils";
import ConfigEditModal from "./configEditModal/ConfigEditModal";
import ConfigTreeEditModal from "./configTreeEditModal/ConfigTreeEditModal";
import { message } from "../utils/sysManagementUtils";
import { Icon, Popover } from "antd";
import ContentWrap from "../components/ContentWrap";

export default class ParamConfiguration extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {

            treeData: [],
            selectedKeys: [],
            treeDataIndex: {
                id: "id",
                title: "name",
                children: "sons",
                key: "id"
            },
            columns: [],
            searchType: "",
            searchValue: "",
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            count: 0,
            tableIsLoading: false,

            expandedKeys: [],
            autoExpandParent: true,

            editTree: null,
            treeEditVisible: false,
            editConfig: null,
            ConfigEditVisible: false,
            selectedRowKeys: [],
            batchDelData:[],// 批量删除
        };
    }

    componentDidMount() {
        this.initData();
        // this.getConfigList();
        this.getConfigCategoryTree();
    }

    render() {
        const {
            treeData,
            searchType,
            columns,
            tableData,
            searchValue,
            currentPage,
            pageSize,
            count,
            tableIsLoading,
            selectedKeys,
            expandedKeys,
            autoExpandParent,
            editTree,
            treeEditVisible,
            editConfig,
            ConfigEditVisible,
            selectedRowKeys,
            batchDelData
        } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        return (
            <ContentWrap>
                {/*// 树 表格 框架的实现*/}
                <TreeAndTableLayout
                    treeData={treeData}
                    // showSearch={true}
                    expandedKeys={expandedKeys}
                    expandKey={this.expandKey}
                    onSelect={this.onSelect}
                    showIcon={false}
                    rowSelection={rowSelection}
                    showRowSelection={true}
                    showTreeOperation={true}
                    onTreeAdd={data => this.showConfigTreeEdit({ fid: data.id })}
                    onTreeEdit={data => this.showConfigTreeEdit(data.data)}
                    onTreeDelete={data => this.onTreeDelete(data)}
                    autoExpandParent={autoExpandParent}
                    selectedKeys={selectedKeys}
                    tableData={tableData}
                    columns={columns}
                    count={count}
                    onExpand={this.onExpand}
                    ToolBar={
                        <ToolBar
                            searchType={searchType}
                            onTypeChange={this.onTypeChange}
                            searchValue={searchValue}
                            onSearchValueChange={searchValue => this.setState({ searchValue })}
                            onSearch={this.onSearch}
                            showConfigEdit={() => this.showConfigEdit({ configCategoryId: selectedKeys[0] })}
                            isParamsConfig={'isParamsConfig'}
                            onDeleteByIds={this.onDeleteByIds}
                            batchDelData={batchDelData}
                            key={this.state.key}
                            onDeleteCall={() => {
                                // 批量删除置空
                                this.setState({
                                    selectedRowKeys: [],
                                    batchDelData: [],
                                })
                            }}
                        />
                    }
                    tableIsLoading={tableIsLoading}
                    current={currentPage}
                    pageSize={pageSize}
                    onChange={this.onPageChange}
                    onShowSizeChange={this.onShowSizeChange}
                />

                <ConfigTreeEditModal
                    visible={treeEditVisible}
                    data={editTree}
                    handleCancel={this.hideConfigTreeEdit}
                    handleOk={this.submitConfigTreeEdit}
                />

                <ConfigEditModal
                    visible={ConfigEditVisible}
                    data={editConfig}
                    handleCancel={this.hideConfigEdit}
                    handleOk={this.submitConfigEdit}
                />
            </ContentWrap>
        );
    }

    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.state.batchDelData = selectedRows;
        this.state.selectedRowKeys = selectedRowKeys;
        if (this.state.tableData) {
            this.state.tableData.map(item => {
                if (item.isEnable === 0) {
                    this.state.batchDelData = selectedRows;
                    this.state.selectedRowKeys = selectedRowKeys;
                }
            })
        }
        this.setState({})
    };
    hideConfigEdit = () => {
        this.setState({
            ConfigEditVisible: false
        });
    };

    /**
     * 展示配置编辑弹窗
     * @param {*} editConfig 
     */
    showConfigEdit = editConfig => {
        this.setState({
            editConfig,
            ConfigEditVisible: true
        });
    };

    /**
     * 提交配置修改/新增
     * @param {*} data 
     */
    submitConfigEdit = data => {
        message.destroy();
        if (data.id) {
            this.configEdit(data);
        } else {
            this.configAdd(data);
        }
    };

    /**
     * 展示树节点修改
     * @param {*} data 
     */
    showConfigTreeEdit = data => {
        this.setState({
            editTree: data,
            treeEditVisible: true
        });
    };

    /**
     * 提交配置节点修改
     * @param {*} data 
     */
    submitConfigTreeEdit = data => {
        message.destroy();
        if (data.id) {
            this.editConfigCategory(data);
        } else {
            this.addConfigCategory(data);
        }
        this.getConfigCategoryTree();
    };

    hideConfigTreeEdit = () => {
        this.setState({
            treeEditVisible: false
        });
    };

    onExpand = expandedKeys => {
        this.setState({
            expandedKeys,
            autoExpandParent: false
        });
    };

    /**
     * 展开指定节点
     * @param {*} key 
     */
    expandKey = key => {
        const { expandedKeys, treeData } = this.state;
        const tree = filterForEach(treeData, node => {
            return node.id === key;
        });
        const keys = [];
        treeForEach(tree, node => {
            keys.push(node.id);
        });
        this.setState({
            expandedKeys: [...(new Set([...expandedKeys, ...keys]))],
            autoExpandParent: false
        });
    };

    // 当树组件选择点击item时触发
    onSelect = (selectKeys, e) => {
        this.setState({
            searchType: "",
            searchValue: "",
            currentPage: 1,
            selectedKeys: selectKeys
        }, () => {
            this.getConfigList();
        });
    };

    // 表格选择类型是的回调 > 表格分类 不是树的点击
    onTypeChange = searchType => {
        this.setState({
            searchType,
            currentPage: 1
        }, () => {
            this.getConfigList();
        });
    };

    // 点击搜索按钮的回调
    onSearch = () => {
        this.setState({
            currentPage: 1
        }, () => {
            this.getConfigList();
        });
    };

    /**
     * 当页码变换的回调
     * @param page
     * @param pageSize
     */
    onPageChange = (page, pageSize) => {
        this.setState({
            currentPage: page,
            pageSize: pageSize,
            selectedRowKeys: [],
            batchDelData: [],
        }, () => {
            this.getConfigList();
        });
    };

    /**
     * pageSize 变化的回调
     * @param current
     * @param size
     */
    onShowSizeChange = (current, size) => {
        this.setState({
            pageSize: size,
            currentPage: 1
        }, () => {
            this.getConfigList();
        });
    };

    // 请求树数据
    getConfigCategoryTree = () => {
        const { selectedKeys, treeDataIndex } = this.state;
        this.getConfigCategoryTreeRequest(res => {
            const treeData = generateTreeData([res], treeDataIndex);
            if (!selectedKeys.length) {
                const expandedKeys = [];
                treeForEach(treeData, node => {
                    if (node.children && node.children.length) {
                        expandedKeys.push(node.id);
                    }
                });
                this.setState({
                    expandedKeys,
                    treeData
                },()=>{
                    this.onSelect( [treeData[0].id])
                });
            }
            this.setState({
                treeData
            });
        });
    };

    // 是否开启/金庸
    onEnableChange = (checked, record) => {
        const id = record.id;
        this.configDisjunctorRequest({id, isEnable: checked}, () => this.getConfigList());
    };

    /**
     * 树节点删除
     * @param {*} data 
     */
    onTreeDelete = data => {
        let selectedKeys = this.state.selectedKeys
        this.delConfigCategoryRequest(data.id, res => {
            message.success(`栏目${data.title}已删除`);
            
            this.setState({
                selectedKeys: selectedKeys.filter(item => item !== data.id)
            },()=>{
                this.getConfigCategoryTree();
            })
        });
    };
    // 初始化页面数据
    initData = () => {
        const columns = [
            {
                title: "名称",
                dataIndex: "configName",
                width: 170,
                ellipsis: true
            },
            {
                title: "类型",
                dataIndex: "configType",
                render: text => findCONFIGURATIONTYPEByValue(text).label,
                width: 100,
                ellipsis: true
            },
            {
                title: "code",
                dataIndex: "configKey",
                width: 110,
                ellipsis: true
            },
            {
                title: "值",
                dataIndex: "configValue",
                ellipsis: true,
                width: 130,
                render: (text, record, index) => {
                    if (record.configType === 3) {
                        return <div style={{
                            width: "100%", height: "40px",
                            backgroundSize: "contain",
                            backgroundPosition: "left center",
                            backgroundRepeat: "no-repeat",
                            backgroundImage: `url(${text})`
                        }}>
                        </div>;
                    } else if (record.configType === 4) {
                        return record.configValueObj ? <Popover
                            content={<div><a href={record.configValueObj.path} download={true}
                                target="_blank">{record.configValueObj.name}</a></div>}
                            title="下载" trigger="hover">
                            <div
                                title={record.configValueObj.name}
                                style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                <Icon type="file-text" style={{ marginRight: 5 }} />
                                <div style={{
                                    flex: "1",
                                    width: "100%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                }}
                                >{record.configValueObj.name}</div>
                            </div>
                        </Popover> : "";
                    }
                    return text;
                }
            },
            {
                title: "是否启用",
                dataIndex: "isEnable",
                width: 100,
                ellipsis: true,
                render: (text, record, index) => {
                    return <CmSwitch checkedChildren={"开"} unCheckedChildren={"关"} checked={text}
                        onChange={checked => this.onEnableChange(checked, record)} />;
                }
            },
            {
                title: "备注",
                dataIndex: "remark",
                width: 160,
                ellipsis: true
            },
            {
                title: "创建人",
                dataIndex: "createBy",
                width: 100,
                ellipsis: true
            },
            {
                title: "操作",
                width: 110,
                render: (text, record, index) => <TableOperation
                    data={record}
                    showConfigEdit={this.showConfigEdit}
                    deleteTableItem={this.deleteTableItem}
                />
            }
        ];
        this.setState({
            columns
        });
    };

    deleteTableItem = data => {
        this.deleteConfigByIdRequest(data.id, res => {
            message.success("配置删除成功");
            this.getConfigList();
        });
    };

    addConfigCategory = data => {
        this.addConfigCategoryRequest(data, res => {
            if (res) {
                this.hideConfigTreeEdit();
                message.success("栏目添加成功");
                this.getConfigCategoryTree();
                this.expandKey(data.fid);
                this.onSelect([res.id]);
            }
        });
    };

    editConfigCategory = data => {
        this.editConfigCategoryRequest(data, res => {
            this.hideConfigTreeEdit();
            this.getConfigCategoryTree();
            message.success("栏目修改成功");
        });
    };
    configEdit = data => {
        this.configEditRequest(data, res => {
            this.hideConfigEdit();
            message.success("配置修改成功");
            this.getConfigList();
        });
    };
    configAdd = data => {
        this.configAddRequest(data, res => {
            message.success("配置添加成功");
            this.setState({
                currentPage: 1
            }, () => {
                this.hideConfigEdit();
                this.getConfigList();
            });
        });
    };
    // 请求配置列表数据
    getConfigList = () => {
        const {
            currentPage: start,
            pageSize: size,
            searchType: configType,
            searchValue: query,
            selectedKeys
        } = this.state;

        // 设置表格正在加载中
        this.setState({
            tableIsLoading: true
        });
        const configCategoryId = selectedKeys[0];

        this.getConfigListRequest({ query, configType, configCategoryId, start, size }, res => {
            const { count } = res;
            if (count !== 0 && count <= (start - 1) * size) {
                this.onPageChange(start - 1, size);
            } else {
                this.setState({
                    tableData: res.data,
                    count: res.count,
                    tableIsLoading: false
                });
            }
        });
    };

    getConfigListRequest = (body, callBack) => {
        this.request({
            url: "/cm-sites-sys/config/list",
            method: "POST",
            body,
            callBack: res => {
                let md5s = [];
                res.data.forEach((item, index) => {
                    if (item.configType === 4) {
                        md5s.push(item.configValue);
                    }
                });
                // 去重
                md5s = md5s.filter((item, index) => md5s.indexOf(item) === index)
                if (md5s.length) {
                    this.getStorageFileList(md5s.join(","), md5sRes => {
                        res.data.forEach(item => {
                            if (item.configType === 4) {
                                item.configValueObj = md5sRes.find(md5Obj => md5Obj.md5 === item.configValue)
                            }
                        });
                        callBack(res);
                    });
                } else {
                    callBack(res);
                }

            }
        });
    };

    configDisjunctorRequest = ({ isEnable, id } = {}, callBack) => {
        this.request({
            url: "/cm-sites-sys/config/disjunctor",
            method: "POST",
            body: { isEnable: isEnable ? 1 : 0, id },
            callBack
        });
    };

    getConfigCategoryTreeRequest = (callBack) => {
        this.request({
            url: "/cm-sites-sys/configCategory/getConfigCategoryTree",
            callBack
        });
    };

    addConfigCategoryRequest = ({ fid, name }, callBack) => {
        this.request({
            url: "/cm-sites-sys/configCategory/add",
            method: "POST",
            contentType: "json",
            body: { fid, name },
            callBack
        });
    };
    editConfigCategoryRequest = ({ id, name }, callBack) => {
        this.request({
            url: "/cm-sites-sys/configCategory/edit",
            method: "POST",
            body: { id, name },
            callBack
        });
    };
    // 批量删除
    onDeleteByIds = () => {
        this.request({
            url: "/cm-sites-sys/config/deleteByIds",
            method: "POST",
            body: this.state.selectedRowKeys,
            contentType: 'json',
            callBack: (res) => {
                if (res) {
                    message.success('删除成功');
                    this.getConfigList();
                }
            }
        })
    };
    delConfigCategoryRequest = (id, callBack) => {
        let params={
            id:id
        };
        this.request({
            url: "/cm-sites-sys/configCategory/deleteById",
            method: "GET",
            body: params,
            callBack
        });
    };

    configAddRequest = ({configName, configKey, configValue, isEnable, configType, remark, configCategoryId, securityLevel}, callBack) => {
        this.request({
            url: "/cm-sites-sys/config/add",
            method: "POST",
            body: {
                configName,
                configKey,
                configValue,
                isEnable: isEnable ? 1 : 0,
                configType,
                remark,
                configCategoryId,
                securityLevel,
            },
            contentType: "json",
            callBack
        });
    };

    configEditRequest = ({ configName, configKey, configValue, isEnable, configType, remark, configCategoryId, id, securityLevel }, callBack) => {
        this.request({
            url: "/cm-sites-sys/config/edit",
            method: "POST",
            contentType: "json",
            body: {
                configName,
                configKey,
                configValue,
                isEnable: isEnable ? 1 : 0,
                configType,
                remark,
                configCategoryId,
                id,
                securityLevel
            },
            callBack
        });
    };

    deleteConfigByIdRequest = (id, callBack) => {
        this.request({
            url: "/cm-sites-sys/config/deleteById",
            method: "POST",
            body: { id },
            callBack
        });
    };

    // /storage/getStorageFileList
    getStorageFileList(md5s, callBack) {
        this.request({
            url: "/storage/getStorageFileList",
            body: { md5s },
            callBack
        });
    }
}
